import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox } from "@components";

import { Pagination } from "@type/taskManagement/pagination";
import { TableColumn } from "./TableColumn";
import { useSettingsOfficeList } from "@hooks/HRM/settings/useSettingsOfficeList";
import { useSettingsOfficeById } from "@hooks/HRM/settings/useSettingsOfficeById";
import { SettingsOfficeResponseType } from "@type/HRM/settings/settings-office";

import { TablePagination } from "@helpers/tablePagination";

type OfficeAddressListTablePropType = {
  handleScrollToTop: () => void;
};

export default function OfficeAddressListTable({
  handleScrollToTop,
}: OfficeAddressListTablePropType) {
  const { t } = useTranslation();
  const { control } = useForm();

  const { handleQuery, officeState } = useSettingsOfficeList();
  const { handleQueryById } = useSettingsOfficeById(false);

  const { getData, createSuccess, updateSuccess, deleteSuccess } = officeState;

  const { data, pagination } = getData || ({} as SettingsOfficeResponseType);
  const { page, total } = pagination || ({} as Pagination);

  useEffect(() => {
    if (createSuccess || deleteSuccess) handleQuery("page", 1);
    else if (updateSuccess) handleQuery("page", page);
  }, [createSuccess, updateSuccess, deleteSuccess]);

  return (
    <div className="pt-12 border-top">
      <Table
        header={{
          title: t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.HEADER"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },

          buttons: [
            <SearchBox
              key="search"
              placeholder={t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.SEARCH")}
              control={control}
              handleQuery={handleQuery}
            />,
          ],
        }}
        columns={TableColumn(t, handleScrollToTop, handleQueryById)}
        // edit={{
        //   customIcon: <IconEdit01 size={24} fill="subtitle1" />,
        //   onClick: (id) => {
        //     handleScrollToTop();
        //     handleQueryById(id);
        //   },
        // }}
        rows={data || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}
